import * as React from 'react'
import { Row, Button, Col, FormControl } from 'react-bootstrap'
import { Article } from '../articlesContainer'

interface UrlInputProps {
	value: string
	index: number
	addUrlInput: (e: any) => void
	removeUrlInput: (index: number) => void
	setUrl: (index: number, value: string) => void
	articles: Article[]
	getAds: (e: any) => void
	offset?: number
}

const UrlInput: React.FunctionComponent<UrlInputProps> = (props) => {
	const renderIcon = () => {
		if (props.index === 0) {
			return (
				<Button bsSize="xs" bsStyle="success" onClick={props.addUrlInput} block>
					Add More
				</Button>
			)
		}
		return (
			<Button bsSize="xs" bsStyle="danger" onClick={() => props.removeUrlInput(props.index)} block>
				Delete
			</Button>
		)
	}
	const handleChange = (event: any) => {
		props.setUrl(props.index, event.target.value)
	}

	const handleKeyDown = (event: any) => {
		if (event.key === 'Enter') {
			props.setUrl(props.index, event.target.value)
			props.getAds(event)
		}
	}
	return (
		<Row>
			<Col sm={9} style={{ marginBottom: '6px' }}>
				<FormControl
					className="contentImport"
					type="text"
					placeholder="url"
					onChange={handleChange}
					onKeyDown={handleKeyDown}
					value={props.value}
				/>
			</Col>
			<Col sm={3}>{renderIcon()}</Col>
		</Row>
	)
}

export default UrlInput
